/**
 * MIS Angular Frontend
 * See README for BACKEND ANALYSIS SUMMARY – 4 Microservices
 */
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading } from '@angular/router';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { appConfig } from './app/app.config';
import { PreloadAllModules } from '@angular/router';
import { JwtInterceptor } from './app/core/interceptors/jwt.interceptor';
import { ErrorInterceptor } from './app/core/interceptors/error.interceptor';
import { environment } from './environments/environment';

// Set global API URL for MFEs to use
(window as any).__API_URL__ = environment.apiGatewayUrl || '';
(window as any).__PERMISSIONS__ = []; // Will be populated after login

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withPreloading(PreloadAllModules),
    ),
    provideHttpClient(withInterceptors([JwtInterceptor, ErrorInterceptor])),
    ...appConfig.providers
  ]
}).catch(err => console.error(err));


